import * as Yup from 'yup';
import { messages } from 'app/config/constants';

export const chamberMemberOverviewFilterSchema = Yup.object({
  oib: Yup.string().min(11, messages.OIB_MIN_MAX_LENGTH).max(11, messages.OIB_MIN_MAX_LENGTH),
});
